
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { inject, Injectable } from '@angular/core';
import { CorporatePositionDto, CorporatePositionsCorporationParameters, PagedResultDto } from '../../models';
import { HttpHelper } from '@umss/shared/utils';

@Injectable({
    providedIn: "root"
})
export class CorporatePositionsCorporationService {    

  private readonly baseUrl = "/api/corporate-positions/corporation";
  private readonly http = inject(HttpClient);

	get(corporationId: string): Observable<CorporatePositionDto[]> {
		return this.http.get<CorporatePositionDto[]>(`${this.baseUrl}/${corporationId}`);
	}

	getAllSearch(corporationId: string, parameters?: CorporatePositionsCorporationParameters): Observable<PagedResultDto<CorporatePositionDto>> {
		const params = HttpHelper.toHttpParams(parameters ?? {});
		return this.http.get<PagedResultDto<CorporatePositionDto>>(`${this.baseUrl}/${corporationId}/search`, { params });
	}

}